import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

function useIsLgBreakpoint() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up('lg'));
}

export default useIsLgBreakpoint;
